/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — day-of checkin; forces logout + a fresh open-org
 *              reload when an authenticated session is already present,
 *              since checkin is always an anonymous flow
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     none (returns undefined)
 *   key:       beforeModel (logout + loadOpenTask if already logged in),
 *              setupController (starts controller.loadDataTask),
 *              resetController (cancels task, clears me/checkAPIMail/saveAPIMe)
 *   uses:      services: session
 *   siblings:  controllers/checkin.js, templates/checkin.hbs
 *   tests:     wave5-coverage-test.js, wave17-route-test.js
 *
 * Route for the day-of arrival checkin flow: guarantees an anonymous session
 * before the controller's contact lookup/creation logic runs.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { inject as iService } from '@ember/service';

export default class CheckinRoute extends Route {
  @iService session;

  async beforeModel() {
    if (this.session.me?.id) {
      this.session.logout();
      await this.session.loadOpenTask.perform(true);
    }
  }

  model() {}

  setupController(controller /*, model*/) {
    super.setupController(...arguments);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
    set(controller, 'me', null);
    set(controller, 'checkAPIMail', null);
    set(controller, 'saveAPIMe', null);
  }
}
